export const types = [
    {
        icon: 'horizontal.svg',
        title: 'Horizontal bar chart',
        type: 'horizontal'
    },
    {
        icon: 'vertical.svg',
        title: 'Vertical bar chart',
        type: 'vertical'
    },
    {
        icon: 'line.svg',
        title: 'Horizontal line chart',
        type: 'line'
    },
    {
        icon: 'vertical-line.svg',
        title: 'Vertical line chart',
        type: 'vertical-line'
    },
    {
        icon: 'pie.svg',
        title: 'Pie chart',
        type: 'pie'
    },
    {
        icon: 'donut.svg',
        title: 'Donut chart',
        type: 'donut'
    },
    {
        icon: 'horizontal-stacked.svg',
        title: 'Horizontal stacked chart',
        type: 'horizontal-stacked'
    },
    {
        icon: 'vertical-stacked.svg',
        title: 'Vertical stacked chart',
        type: 'vertical-stacked'
    },
    {
        icon: 'horizontal-area.svg',
        title: 'Horizontal area chart',
        type: 'horizontal-area'
    },
    {
        icon: 'vertical-area.svg',
        title: 'Vertical area chart',
        type: 'vertical-area'
    },
    {
        icon: 'horizontal-smooth-line.svg',
        title: 'Horizontal smooth line chart',
        type: 'horizontal-smooth-line'
    },
    {
        icon: 'vertical-smooth-line.svg',
        title: 'Vertical smooth line chart',
        type: 'vertical-smooth-line'
    },
    {
        icon: 'vertical-smooth-area.svg',
        title: 'Vertical smooth area chart',
        type: 'vertical-smooth-area'
    },
    {
        icon: 'horizontal-smooth-area.svg',
        title: 'Horizontal smooth area chart',
        type: 'horizontal-smooth-area'
    }
];